import { render, staticRenderFns } from "./TipTapEditor.vue?vue&type=template&id=755a86d5&scoped=true"
import script from "./TipTapEditor.vue?vue&type=script&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&lang=js"
import style0 from "./TipTapEditor.vue?vue&type=style&index=0&id=755a86d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a86d5",
  null
  
)

export default component.exports